import React from "react";
import {
  LoadingOverlayContainer,
  LoadingSpinner,
  LoadingText,
  LoadingSubtext,
} from "./styled";

interface LoadingOverlayProps {
  isVisible: boolean;
  title?: string;
  subtitle?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  title = "Conectando con el asistente...",
  subtitle = "Por favor espera mientras establecemos la conexión",
}) => {
  if (!isVisible) return null;

  return (
    <LoadingOverlayContainer>
      <LoadingSpinner />
      {title && <LoadingText>{title}</LoadingText>}
      {subtitle && <LoadingSubtext>{subtitle}</LoadingSubtext>}
    </LoadingOverlayContainer>
  );
};

export default LoadingOverlay;
